import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgXShare = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 48,
  viewBox: "0 0 49 48",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#a)",
    children: /*#__PURE__*/_jsx("path", {
      fill: "#2D2E31",
      d: "M24.333 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24c-.001-13.255-10.746-24-24-24m3.97 36.588-6.217-8.685-8.12 8.685H10.28L20.487 25.67 10.28 11.411h10.084l5.836 8.15 7.62-8.15h3.686l-9.708 10.383 10.59 14.793zM18.99 14.081l14.201 19.836h-3.515L15.474 14.081z"
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M.333 0h48v48h-48z"
      })
    })
  })]
});
export default SvgXShare;